import { z } from 'zod';

import { emailSchema, roleSchema } from '@web/utils';

export const inviteMemberSchema = z.object({
  invitee_email: emailSchema,
  message: z.string().optional().default(''),
  role_slug: roleSchema,
});
